module.exports = __webpack_public_path__ + "img/staff-2002-jinggangshan.36fd56e6.jpg";